<template>
  <v-flex v-if="loaded">
    <tab-title
      :car-id="appointment.car.id"
      text="装備品" />
    <cp-radio-confirm-desc
      v-model="carFields['P_S']"
      :confirm-value="carFields['P_S_MOVEMENT_CONFIRM']"
      :description="carFields['P_S_MOVEMENT_CONFIRM_DESCRIPTION']"
      :car-fields="carFields"
      :update-item="updateEquipment"
      name="P_S"
      data-label-scroll="P_S"
      label="パワーステアリング(P/S)"
      @change="(value) => updateEquipment('P_S', value)" />
    <cp-radio-confirm-desc
      :value="carFields['P_W']"
      :confirm-value="carFields['P_W_MOVEMENT_CONFIRM']"
      :description="carFields['P_W_MOVEMENT_CONFIRM_DESCRIPTION']"
      :car-fields="carFields"
      :update-item="updateEquipment"
      name="P_W"
      data-label-scroll="P_W"
      label="パワーウィンドウ(P/W)"
      @change="(value) => updateEquipment('P_W', value)" />
    <cp-radio-confirm-desc
      :value="carFields['ELECTRIC_EXTERIOR_MIRRORS']"
      :confirm-value="carFields['ELECTRIC_EXTERIOR_MIRRORS_MOVEMENT_CONFIRM']"
      :description="carFields['ELECTRIC_EXTERIOR_MIRRORS_MOVEMENT_CONFIRM_DESCRIPTION']"
      :car-fields="carFields"
      :update-item="updateEquipment"
      name="ELECTRIC_EXTERIOR_MIRRORS"
      data-label-scroll="ELECTRIC_EXTERIOR_MIRRORS"
      label="電動格納式ミラー"
      @change="(value) => updateEquipment('ELECTRIC_EXTERIOR_MIRRORS', value)" />
    <cp-radio-confirm-desc
      :value="carFields['S_R']"
      :confirm-value="carFields['S_R_MOVEMENT_CONFIRM']"
      :description="carFields['S_R_MOVEMENT_CONFIRM_DESCRIPTION']"
      :car-fields="carFields"
      :update-item="updateEquipment"
      name="S_R"
      data-label-scroll="S_R"
      label="サンルーフ(S/R)"
    />
    <v-select
      :value="carFields['SHEET_MATERIAL']"
      :items="seatMaterial"
      :rules="[$rules.isRequired]"
      label="シート *"
      data-label-scroll="SHEET_MATERIAL"
      @change="(val) => updateEquipment('SHEET_MATERIAL', val)"
    />
    <v-text-field
      v-if="carFields['SHEET_MATERIAL'] === 'OTHER'"
      :value="carFields['SHEET_MATERIAL_DESCRIPTION']"
      :rules="[$rules.isRequired]"
      label="具体的に *"
      @blur="({ target }) => updateEquipment(
        'SHEET_MATERIAL_DESCRIPTION', target._value
      )"
    />
    <cp-radio-confirm-desc
      :value="carFields['NAVIGATION']"
      :confirm-value="carFields['NAVIGATION_MOVEMENT_CONFIRM']"
      :description="carFields['NAVIGATION_MOVEMENT_CONFIRM_DESCRIPTION']"
      :car-fields="carFields"
      :update-item="updateEquipment"
      name="NAVIGATION"
      data-label-scroll="NAVIGATION"
      label="ナビ"
      hint="ポータブルナビの場合は「なし」を選択。"
    />
    <cp-radio-confirm-desc
      :value="carFields['TV']"
      :confirm-value="carFields['TV_MOVEMENT_CONFIRM']"
      :description="carFields['TV_MOVEMENT_CONFIRM_DESCRIPTION']"
      :car-fields="carFields"
      :update-item="updateEquipment"
      name="TV"
      data-label-scroll="TV"
      label="TV"
      hint="アナログテレビのみの場合は「なし」を選択。"
    >
      <v-dialog
        slot="hint"
        v-model="tvHint"
        max-width="300"
      >
        <v-icon
          slot="activator"
          color="amber darken-4"
          style="cursor: pointer"
        >help</v-icon>
        <v-card>
          <v-card-title class="pa-0">
            <v-spacer />
            <v-btn
              icon
              @click="tvHint = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-0">
            地上デジタル、ワンセグを受信し見ることができるもののみテレビとして扱う。
            アナログテレビのみの場合、テレビには含まれない。
            <div class="mb-3"/>
            <img
              src="../../assets/tv1.jpg"
              width="100%"
            >
            <div class="mb-3"/>
            <img
              src="../../assets/tv2.jpg"
              width="100%"
            >
          </v-card-text>
        </v-card>
      </v-dialog>
    </cp-radio-confirm-desc>
    <cp-radio
      :value="carFields['A_W']"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="アルミホイール(A/W) *"
      data-label-scroll="A_W"
      @change="(value) => updateEquipment('A_W', value)" />
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      to="sales-points#top">次へ</v-btn>
  </v-flex>
</template>

<script>
import {
  getCarWith,
  GET_CAR_FIELDS,
} from '../../queries';

import {
  yesOrNo,
  detailsBasic,
  seatMaterial,
} from '../../options';

const defaultCarFields = [
  'P_S',
  'P_S_MOVEMENT_CONFIRM',
  'P_S_MOVEMENT_CONFIRM_DESCRIPTION',
  'P_W',
  'P_W_MOVEMENT_CONFIRM',
  'P_W_MOVEMENT_CONFIRM_DESCRIPTION',
  'ELECTRIC_EXTERIOR_MIRRORS',
  'ELECTRIC_EXTERIOR_MIRRORS_MOVEMENT_CONFIRM',
  'ELECTRIC_EXTERIOR_MIRRORS_MOVEMENT_CONFIRM_DESCRIPTION',
  'S_R',
  'SHEET_MATERIAL',
  'SHEET_MATERIAL',
  'SHEET_MATERIAL_DESCRIPTION',
  'NAVIGATION',
  'NAVIGATION_MOVEMENT_CONFIRM',
  'NAVIGATION_MOVEMENT_CONFIRM_DESCRIPTION',
  'TV',
  'TV_MOVEMENT_CONFIRM',
  'TV_MOVEMENT_CONFIRM_DESCRIPTION',
  'A_W',
].reduce((acc, cur) => ({
  ...acc,
  [cur]: null,
}), {});

export default {
  props: {
    appointmentId: {
      type: [String, Number],
      default: '',
    },
  },
  apollo: {
    carFields: {
      query: GET_CAR_FIELDS,
      fetchPolicy: 'network-only',
      skip() {
        return !this.appointment || !this.appointment.car.id;
      },
      variables() {
        return {
          carId: this.appointment.car.id,
        };
      },
      update({ carFields }) {
        this.loaded = true;
        return {
          ...defaultCarFields,
          ...carFields.data.reduce((acc, cur) => ({
            ...acc,
            [cur.code]: cur.value,
          }), {}),
        };
      },
    },
    appointment: {
      query: getCarWith(),
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
      result() {
        this.$apollo.queries.carFields.refetch();
      },
    },
  },
  data() {
    return {
      tab: 'equipment',
      yesOrNo,
      detailsBasic,
      loaded: false,
      seatMaterial,
      tvHint: false,
      carFields: defaultCarFields,
    };
  },
  methods: {
    updateEquipment(code, value) {
      return this.updateField({
        code,
        value,
        carId: this.appointment.car.id,
        typeId: 79,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/EquipmentTab.vue